import type { TextMaterialCategory } from '@@partner:types:app'

import React from 'react'
import {
  formatDate
} from '@@partner:helpers/util'

import { Link, generatePath } from 'react-router-dom'
import { Button, ButtonGroup, Table, Tag } from 'rsuite'
import AppLoader from '@components/common/AppLoader'

import {
  ROUTE_TEXT_MATERIALS_CATEGORIES_EDIT
} from '@@partner:config/routes'
import TextMaterialCategoryStatusLabel from '../common/TextMaterialCategoryStatusLabel'

const Column = Table.Column
const HeaderCell = Table.HeaderCell
const Cell = Table.Cell

export interface TextMaterialCategoriesTableProps {
  brandSlug: string
  textMaterialCategories: TextMaterialCategory[]
  loading?: boolean
}

export default function TextMaterialCategoriesTable ({
  brandSlug,
  textMaterialCategories = [],
  loading = false
}: TextMaterialCategoriesTableProps) {

  return (
    <Table
      data={textMaterialCategories}
      autoHeight
      wordWrap
      loading={loading}
      renderLoading={() =>
        loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
      }
      affixHeader
      rowHeight={120}
      className="TextMaterialCategoriesTable"
    >
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>ID</HeaderCell>
        <Cell dataKey="id"></Cell>
      </Column>
      <Column flexGrow={3} verticalAlign="middle">
        <HeaderCell>Название</HeaderCell>
        <Cell dataKey="name"></Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Статус</HeaderCell>
        <Cell dataKey="status">
          {(category: TextMaterialCategory) => (
            <>
              <TextMaterialCategoryStatusLabel status={category.status} />
            </>
          )}
        </Cell>
      </Column>
      <Column flexGrow={3} verticalAlign="middle">
        <HeaderCell>Заголовок</HeaderCell>
        <Cell dataKey="title">
          {(category: TextMaterialCategory) => (
            <div>
              { category?.i18n?.map(translation => (
                <div key={translation.languageCode}>
                  {translation.languageCode}: {translation.title}
                </div>
              ))}
            </div>
          )}
        </Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Создан</HeaderCell>
        <Cell dataKey="created_at">
          {(textMaterial: TextMaterialCategory) => (
            <Tag color="blue">{formatDate(new Date(textMaterial.created_at))}</Tag>
          )}
        </Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Обновлен</HeaderCell>
        <Cell dataKey="updated_at">
          {(textMaterial: TextMaterialCategory) => (
            <Tag color="blue">{formatDate(new Date(textMaterial.updated_at))}</Tag>
          )}
        </Cell>
      </Column>

      <Column flexGrow={4} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(category: TextMaterialCategory) => (
            <ButtonGroup>
              <Button
                color="cyan"
                appearance="primary"
                as={Link}
                to={generatePath(ROUTE_TEXT_MATERIALS_CATEGORIES_EDIT, {
                  brandSlug,
                  categoryId: category.id
                })}
                size="xs"
              >
                Изменить
              </Button>
            </ButtonGroup>
          )}
        </Cell>
      </Column>
    </Table>
  )
}
